// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RakutenRoom from '../_raw/ui/icon_rakuten_room.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RakutenRoom);
